const ee = new PIXI.utils.EventEmitter();

class Test {
  static get eventEmitter() {
    return ee;
  }

  constructor( timestables, questions ) {
    this.timestables = timestables;
    this.questions = questions;
    this.currentQuestionIndex = -1;
  }

  get currentQuestion() {
    return this.questions[ this.currentQuestionIndex ];
  }

  get numQuestions() {
    return this.questions.length;
  }

  get isOnLastQuestion() {
    return this.numQuestions === this.currentQuestionIndex + 1;
  }

  get last5AnswerResults() {
    var results = new Array(5).fill(undefined);

    for ( var i = 0; i < 5; i++ ) {
      const rIx = 4 - i;
      const qIx = this.currentQuestionIndex - i - 1;
      if ( qIx < 0 ) {
        break;
      }
      results[ rIx ] = this.questions[ qIx ].result;
    }

    return results;
  }

  get score() {
    return this.questions.reduce(( score, question ) => {
      if ( question.result ) {
        score.correct++;
      }
      score.total++;
      return score;
    }, { correct: 0, total: 0 });
  }

  scoreForTimestable( timestable ) {
    return this.questions.reduce(( score, question ) => {
      if ( question.multiplicand === timestable || question.multiplier === timestable ) {
        if ( question.result ) {
          score.correct++;
        }
        score.total++;
      }
      return score;
    }, { correct: 0, total: 0 });
  }

  gotoNextQuestion() {
    this.currentQuestionIndex++;

    if ( this.currentQuestionIndex >= this.numQuestions ) {
      this.currentQuestionIndex = -1;
    } else {
      this.currentQuestion.tool.loadQuestion(this.currentQuestion);
      Test.eventEmitter.emit('TEST_NEXT_QUESTION', this);
    }
  }

  start() {
    Test.eventEmitter.emit('TEST_START', this);
    this.gotoNextQuestion();
  }

  end() {
    Test.eventEmitter.emit('TEST_END', this);
  }

  exit() {
    Test.eventEmitter.emit('TEST_EXIT', this);
  }
}

export default Test;
